/*
 * Copyright (C) 2026 - Potentially Ltd
 *
 * Please see distribution for license.
 */

import { Injectable } from '@angular/core';
import { NestedPathHelper } from '@app/app/shared/helpers/nested-path.helper';
import { Organization } from '@app/app/shared/models';

@Injectable({ providedIn: 'root' })
export class ShareUrlService {
  buildOrganizationEntityUrl(organization: Pick<Organization, 'domain'>, currentUrl: string, fallbackPath: string): string {
    const entityPath = NestedPathHelper.parsePath(currentUrl)?.fullPath ?? fallbackPath;

    return this.buildOrganizationUrl(organization, entityPath);
  }

  /**
   * A link to hand to someone else. Until the organisation has loaded its domain isn't known, so the page's own
   * origin stands in — the same host the app is served from — rather than a relative path, which means nothing
   * once it is pasted somewhere else.
   */
  buildShareableUrl(organization: Pick<Organization, 'domain'> | null | undefined, path: string): string {
    return organization ? this.buildOrganizationUrl(organization, path) : new URL(path, window.location.origin).toString();
  }

  buildOrganizationUrl(organization: Pick<Organization, 'domain'>, path: string): string {
    const domain = organization.domain
      .trim()
      .replace(/^https?:\/\//i, '')
      .replace(/\/+$/, '');
    const normalizedPath = path.replace(/^\/+/, '');

    return `https://${domain}/${normalizedPath}`;
  }
}
